import { useTranslation } from 'react-i18next';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50],
}) => {
  const { t } = useTranslation();

  if (totalPages <= 1 && !onPageSizeChange) {
    if (onPageSizeChange) {
      return (
        <div className="flex items-center gap-2 text-sm text-zinc-600 dark:text-zinc-500">
          <span>{t('common.perPage')}</span>
          {pageSizeOptions.map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => onPageSizeChange(n)}
              className={`rounded px-2 py-1 ${
                pageSize === n ? 'bg-glow-600/20 text-glow-300' : 'hover:bg-zinc-100 dark:hover:bg-zinc-800'
              }`}
            >
              {n}
            </button>
          ))}
        </div>
      );
    }
    return null;
  }

  const pages = [];
  const add = (p) => pages.push(p);
  const showEllipsis = totalPages > 7;

  if (!showEllipsis) {
    for (let i = 1; i <= totalPages; i += 1) add(i);
  } else {
    add(1);
    if (currentPage > 3) add('…');
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i += 1) {
      add(i);
    }
    if (currentPage < totalPages - 2) add('…');
    add(totalPages);
  }

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      {onPageSizeChange && (
        <div className="flex items-center gap-2 text-sm text-zinc-600 dark:text-zinc-500">
          <span>{t('common.perPage')}</span>
          {pageSizeOptions.map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => onPageSizeChange(n)}
              className={`rounded px-2 py-1 ${
                pageSize === n ? 'bg-glow-600/20 text-glow-300' : 'hover:bg-zinc-100 dark:hover:bg-zinc-800'
              }`}
            >
              {n}
            </button>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div className="flex items-center gap-1">
          <button
            type="button"
            disabled={currentPage <= 1}
            onClick={() => onPageChange(currentPage - 1)}
            className="rounded-lg px-3 py-1.5 text-sm text-zinc-600 dark:text-zinc-400 hover:bg-zinc-100 dark:hover:bg-zinc-800 disabled:opacity-40"
          >
            {t('common.prev')}
          </button>
          {pages.map((p, idx) =>
            p === '…' ? (
              <span key={`e-${idx}`} className="px-2 text-zinc-600 dark:text-zinc-500">
                …
              </span>
            ) : (
              <button
                key={p}
                type="button"
                onClick={() => onPageChange(p)}
                className={`min-w-[2rem] rounded-lg px-2 py-1.5 text-sm ${
                  currentPage === p ? 'bg-glow-600/20 text-glow-300' : 'text-zinc-600 dark:text-zinc-400 hover:bg-zinc-100 dark:hover:bg-zinc-800'
                }`}
              >
                {p}
              </button>
            )
          )}
          <button
            type="button"
            disabled={currentPage >= totalPages}
            onClick={() => onPageChange(currentPage + 1)}
            className="rounded-lg px-3 py-1.5 text-sm text-zinc-600 dark:text-zinc-400 hover:bg-zinc-100 dark:hover:bg-zinc-800 disabled:opacity-40"
          >
            {t('common.next')}
          </button>
        </div>
      )}
    </div>
  );
};

export default Pagination;
